<template>
  <div
    id="side_bar"
    :class="[sideBarStatus ? 'w-80' : 'w-16']"
    class="fixed top-0 right-0 bottom-0 duration-500 z-40 flex flex-col overflow-hidden"
    style="background: linear-gradient(180deg,#0a1628 0%,#0f2040 55%,#0d1c38 100%); box-shadow: -6px 0 32px -4px rgba(0,0,0,.5);"
  >
    <!-- Brand / Toggle Header -->
    <div class="flex items-center gap-3 flex-shrink-0 px-3 pt-5 pb-4"
         style="border-bottom:1px solid rgba(255,255,255,.07);">
      <!-- Logo icon — click to toggle -->
      <div
        class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 cursor-pointer duration-300 select-none"
        style="background: linear-gradient(135deg,#10b981,#059669); box-shadow: 0 8px 20px -6px rgba(16,185,129,.6);"
        @click="toggleSideBarStatus()"
      >
        <i class="fas text-white text-sm"
           :class="sideBarStatus ? 'fa-chevron-right' : 'fa-bars'"></i>
      </div>
      <!-- Brand text — collapses out -->
      <div
        class="overflow-hidden duration-500 flex-1 min-w-0"
        :style="sideBarStatus ? 'opacity:1;max-width:999px;' : 'opacity:0;max-width:0;'"
      >
        <h1 class="font-bold text-white text-base leading-tight tracking-wide whitespace-nowrap">لوحة التحكم</h1>
        <span class="text-sm font-medium whitespace-nowrap" style="color:rgba(16,185,129,.8);">المندلاوي</span>
      </div>
    </div>

    <!-- Navigation -->
    <nav class="flex-1 overflow-y-auto py-4" :class="sideBarStatus ? 'px-3' : 'px-2'"
         style="scrollbar-width:none;">
      <div v-for="(group, gi) in sidebarGroups" :key="gi">

        <!-- Group label (expanded only) -->
        <div v-show="sideBarStatus"
             class="flex items-center gap-2 px-2 mb-2"
             :class="gi > 0 ? 'mt-5' : ''">
          <span class="text-xs font-bold uppercase tracking-widest whitespace-nowrap"
                style="color:rgba(255,255,255,.25);">{{ group.label }}</span>
          <div class="flex-1 h-px" style="background:rgba(255,255,255,.06);"></div>
        </div>
        <!-- Thin divider (collapsed only) -->
        <div v-show="!sideBarStatus && gi > 0"
             class="my-3 mx-1 h-px" style="background:rgba(255,255,255,.08);"></div>

        <ul class="space-y-1">
          <li v-for="(item, index) in group.items" :key="index">
            <router-link
              v-if="checkRole(item.permissions)"
              exact
              active-class="nav-active"
              :to="item.link"
              class="nav-link flex items-center rounded-xl duration-300"
              :class="sideBarStatus ? 'gap-3 px-3 py-3' : 'justify-center py-3'"
              :title="sideBarStatus ? '' : item.title"
            >
              <span class="nav-icon w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 text-base duration-300">
                <i :class="item.icon"></i>
              </span>
              <span
                class="text-base font-medium leading-none whitespace-nowrap overflow-hidden duration-300"
                :style="sideBarStatus ? 'opacity:1;max-width:999px;' : 'opacity:0;max-width:0;'"
              >{{ item.title }}</span>
              <span
                v-show="sideBarStatus"
                class="nav-dot mr-auto w-1.5 h-1.5 rounded-full opacity-0 flex-shrink-0 duration-300"
                style="background:#10b981;"
              ></span>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Logout -->
    <div class="flex-shrink-0 pt-3 pb-5"
         :class="sideBarStatus ? 'px-3' : 'px-2'"
         style="border-top:1px solid rgba(255,255,255,.07);">
      <button
        @click.prevent="logOutUser()"
        class="logout-btn flex items-center rounded-xl w-full duration-300"
        :class="sideBarStatus ? 'gap-3 px-3 py-3' : 'justify-center py-3'"
        :title="sideBarStatus ? '' : 'تسجيل الخروج'"
      >
        <span class="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 text-base duration-300"
              style="background:rgba(239,68,68,.15); color:#ef4444;">
          <i class="fas fa-sign-out-alt"></i>
        </span>
        <span
          class="text-base font-medium whitespace-nowrap overflow-hidden duration-300"
          :style="sideBarStatus ? 'opacity:1;max-width:999px;' : 'opacity:0;max-width:0;'"
          style="color:rgba(255,255,255,.5);"
        >تسجيل الخروج</span>
      </button>
    </div>
  </div>
</template>

<style>
@media print { #side_bar { display: none !important; } }

/* Scrollbar hide */
#side_bar nav::-webkit-scrollbar { display: none; }

/* Nav link default */
.nav-link { color: rgba(255,255,255,.45); }
.nav-link .nav-icon {
  background: rgba(255,255,255,.05);
  color: rgba(255,255,255,.35);
}

/* Nav link hover */
.nav-link:hover {
  background: rgba(255,255,255,.07);
  color: rgba(255,255,255,.9);
}
.nav-link:hover .nav-icon {
  background: rgba(16,185,129,.18);
  color: #10b981;
}

/* Nav link active */
.nav-link.nav-active {
  background: linear-gradient(135deg, rgba(16,185,129,.18), rgba(16,185,129,.08)) !important;
  color: #10b981 !important;
  box-shadow: inset 3px 0 0 #10b981;
}
.nav-link.nav-active .nav-icon {
  background: rgba(16,185,129,.25) !important;
  color: #10b981 !important;
}
.nav-link.nav-active .nav-dot { opacity: 1 !important; }

/* Logout hover */
.logout-btn:hover { background: rgba(239,68,68,.08); }
.logout-btn:hover span:first-child { background: rgba(239,68,68,.25) !important; }
.logout-btn:hover span:last-child  { color: #ef4444 !important; }
</style>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      sidebarGroups: [
        {
          label: "الرئيسية",
          items: [
            { title: "الطلبات",        link: "/orders",             icon: "fas fa-clipboard-list",  permissions: ["show-user","store-user","update-user","delete-user"] },
            { title: "أرشيف الطلبات",  link: "/archive-order",     icon: "fas fa-archive",         permissions: ["get-Orders"] },
            { title: "احصائيات شاملة", link: "/statistics-orders", icon: "fas fa-chart-bar",       permissions: ["show-owner-sections"] },
          ],
        },
        {
          label: "الأقسام",
          items: [
            { title: "جـــك",     link: "/jek-list",      icon: "fas fa-tools",          permissions: ["get-Jek","get-Jek-Orders","show-Jek","store-Jek"] },
            { title: "داينو",     link: "/daino-list",    icon: "fas fa-tachometer-alt", permissions: ["get-Daino","get-Daino-Orders","show-Daino","store-Daino"] },
            { title: "كمبيوتر",   link: "/computer-list", icon: "fas fa-laptop",         permissions: ["get-Computer","get-Computer-Orders","show-Computer","store-Computer"] },
            { title: "فحص البدي", link: "/cover-list",    icon: "fas fa-car",            permissions: ["get-Cover","get-Cover-Orders","show-Cover","store-Cover"] },
          ],
        },
        {
          label: "الإدارة",
          items: [
            { title: "المستخدمين",        link: "/users",                  icon: "fas fa-users",      permissions: ["show-owner-sections"] },
            { title: "طلبات الصيانة",      link: "/maintenance_orders",     icon: "fas fa-wrench",     permissions: ["accountant-all"] },
            { title: "احصائيات الحسابات", link: "/accountant-calculation", icon: "fas fa-chart-line", permissions: ["accountant-all"] },
            { title: "الحسابات",           link: "/accountant/1",           icon: "fas fa-calculator", permissions: ["update-user"] },
          ],
        },
      ],
    };
  },
  methods: {
    logOutUser() {
      Swal.fire({
        title: "تسجيل الخروج",
        text: "سيتم تسجيل الخروج من الحساب الحالي",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#94a3b8",
        confirmButtonText: '<i class="fas fa-sign-out-alt ml-1"></i> تسجيل الخروج',
        cancelButtonText:  '<i class="fas fa-times ml-1"></i> الغاء',
        background: "#fff",
        color: "#1e293b",
        iconColor: "#f59e0b",
        reverseButtons: true,
        customClass: {
          popup:         "swal-custom-popup",
          title:         "swal-custom-title",
          htmlContainer: "swal-custom-text",
          confirmButton: "swal-custom-btn",
          cancelButton:  "swal-custom-btn",
          actions:       "swal-custom-actions",
        },
        showClass: { popup: "swal-show-animation" },
        hideClass: { popup: "swal-hide-animation" },
      }).then((result) => {
        if (result.isConfirmed) {
          this.logOut().then(() => { this.$router.push("/"); });
        }
      });
    },
  },
  mounted() {
    if (window.innerWidth < 768) { this.toggleSideBarStatus(); }
  },
};
</script>
